"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdminNames = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const roles = __importStar(require("../../../../../common/constants/roles"));
const teamQuery_1 = require("../../../../queries/teamQuery");
const columns_1 = require("./columns");
const getTableData_1 = require("./getTableData");
const lexico = new lexico_1.default();
const getAdminNames = team => {
    const ADMINS_TO_DISPLAY = 2;
    const teamAdmin = roles.teamAdmin.id;
    const filteredTeamUsers = team.users
        ?.filter(user => {
        return user?.roles.some(role => role.roleId === teamAdmin);
    })
        .map(user => user.fullName);
    if (filteredTeamUsers?.length > ADMINS_TO_DISPLAY) {
        const count = filteredTeamUsers.length - ADMINS_TO_DISPLAY;
        return `${filteredTeamUsers.slice(0, ADMINS_TO_DISPLAY).join(', ')} +${count} more`;
    }
    else {
        return filteredTeamUsers?.join(', ');
    }
};
exports.getAdminNames = getAdminNames;
const TeamTable = ({ tableId, onActionButtonClick }) => {
    const rowId = (0, react_1.useId)();
    const [page, setPage] = (0, react_1.useState)(1);
    const [offset, setOffset] = (0, react_1.useState)(0);
    const [isSearchInput, setIsSearchInput] = (0, react_1.useState)(false);
    const [searchVal, setSearchVal] = (0, react_1.useState)('');
    const LIMIT = 10; // it can not be greater than 10
    const { data: allTeams } = (0, teamQuery_1.useGetAllTeamsQuery)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teams, isFetching: isGetTeamsFetching } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamsQuery)({ offset, limit: LIMIT }),
        initialData: initialData.teams,
    });
    const [teamsArr, setTeamsArr] = (0, react_1.useState)(teams || []);
    const totalCount = (teams && teams[0] && teams[0].teamsCount) || 0;
    const totalPages = Math.ceil(totalCount / LIMIT);
    const searchTeamName = val => {
        setSearchVal(val);
        const filteredRows = allTeams?.filter(row => {
            return row.name.toLowerCase().includes(val.toLowerCase());
        });
        setTeamsArr(filteredRows || []);
    };
    (0, react_1.useEffect)(() => {
        if (teams && teams.length > 0) {
            setTeamsArr(teams);
        }
    }, [teams]);
    const tableData = (0, react_1.useMemo)(() => {
        return (0, getTableData_1.getTableData)(teamsArr, onActionButtonClick);
    }, [teamsArr]);
    (0, react_1.useEffect)(() => {
        setOffset((page - 1) * LIMIT);
    }, [page]);
    const onSearch = () => {
        setIsSearchInput(true);
        return {};
    };
    (0, react_1.useEffect)(() => {
        if (!searchVal) {
            setIsSearchInput(false);
        }
    }, [searchVal]);
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { children: (0, jsx_runtime_1.jsx)(material_1.TableContainer, { children: (0, jsx_runtime_1.jsxs)(material_1.Table, { id: tableId, "data-testid": tableId, children: [(0, jsx_runtime_1.jsx)(material_1.TableHead, { children: (0, jsx_runtime_1.jsx)(material_1.TableRow, { children: columns_1.columns.map(column => ((0, jsx_runtime_1.jsx)(material_1.TableCell, { "data-test-id": column.id, sx: { textTransform: 'uppercase' }, children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { display: 'flex' }, onClick: () => onSearch(), children: [column.id === 'teamName' && ((0, jsx_runtime_1.jsx)(material_1.IconButton, { name: "searchIcon", children: (0, jsx_runtime_1.jsx)(Search_1.default, {}) })), isSearchInput && column.id === 'teamName' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Input, { "ts-variant": "searchTeamNameInput", onBlur: () => !searchVal && setIsSearchInput(false), autoFocus: true, name: "search", value: searchVal, onChange: e => searchTeamName(e.target.value) }), searchVal && ((0, jsx_runtime_1.jsx)(material_1.IconButton, { name: "cancelIcon", onClick: () => searchTeamName(''), children: (0, jsx_runtime_1.jsx)(Cancel_1.default, { sx: { color: '#4f6b77', cursor: 'pointer' } }) }))] })) : (column.ui())] }) }, `${column.id}-thead`))) }) }), (0, jsx_runtime_1.jsx)(material_1.TableBody, { children: isGetTeamsFetching ? ((0, jsx_runtime_1.jsx)(material_1.TableRow, { children: (0, jsx_runtime_1.jsx)(material_1.TableCell, { align: "center", colSpan: columns_1.columns.length || 6, children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { color: "primary" }) }) })) : teamsArr.length > 0 ? (tableData.map((data, index) => ((0, jsx_runtime_1.jsx)(material_1.TableRow, { hover: true, children: data.map(cell => ((0, jsx_runtime_1.jsx)(material_1.TableCell, { "data-testid": cell.id, children: cell.ui() }, `${cell.id}-${rowId}`))) }, `${rowId}-${index}`)))) : ((0, jsx_runtime_1.jsx)(material_1.TableRow, { children: (0, jsx_runtime_1.jsx)(material_1.TableCell, { colSpan: columns_1.columns.length || 6, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: lexico.tr('No data to display') }) }) })) }), tableData.length > 0 ? ((0, jsx_runtime_1.jsx)(material_1.TableFooter, { className: "page-numbers", children: (0, jsx_runtime_1.jsx)(material_1.TableRow, { hover: true, children: (0, jsx_runtime_1.jsx)(material_1.TableCell, { colSpan: columns_1.columns.length, children: (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }, children: (0, jsx_runtime_1.jsx)(material_1.Pagination, { count: totalPages, page: page, onChange: (_, newPage) => {
                                            setPage(newPage);
                                        }, showFirstButton: true, showLastButton: true, color: "primary" }) }) }) }) })) : null] }) }) }));
};
exports.default = TeamTable;
